const SpiceLevel = () => {
  return (
    <div className="row">
      <div className="col">
        <i className="fa fa-star"></i> Mild
        <i className="fa fa-star"></i>
        <i className="fa fa-star"></i>Spicy
        <i className="fa fa-star"></i>
        <i className="fa fa-star"></i>
        <i className="fa fa-star"></i>Hot and Spicy
      </div>
    </div>
  );
}

export default SpiceLevel;
